import React from 'react';

import { EditableComponent } from '@adobe/aem-react-editable-components';
import { RichText } from '@marriott/mi-ui-library';
import { StyledModalPageContent } from './ModalPageContent.styles';
import { ModalPageContentProps } from './ModalPageContent.types';
import DOMPurify from 'isomorphic-dompurify';

export const ModalPageContentConfig = {
  emptyLabel: 'ModalPageContent',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/legalmodal`,
};

export const ModalPageContent = (props: ModalPageContentProps) => {
  return (
    <EditableComponent config={ModalPageContentConfig} {...props}>
      <ModalPageContentComp {...props} />
    </EditableComponent>
  );
};

const ModalPageContentComp: React.FC<ModalPageContentProps> = ({ title, content }) => {
  const sanitizedContent = DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });

  return (
    <StyledModalPageContent data-testid="legal-ModalPageContent" data-component-name="o-legal-ModalPageContent">
      <div className="m-modal">
        <div className="m-modal-header">{title}</div>
        <div className="m-modal-body">
          <div className="m-modal-content">
            <RichText text={sanitizedContent} componentId="richtext-modal-content" />
          </div>
        </div>
      </div>
    </StyledModalPageContent>
  );
};
